import React, { useState, useEffect, useRef } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

function SearchFilter({ onSearch }) {
  // Helper untuk mendapatkan string tanggal hari ini (YYYY-MM-DD)
  const getTodayStr = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const todayStr = getTodayStr();
  const [searchQuery, setSearchQuery] = useState('');
  const [bahasa, setBahasa] = useState('');
  const [date, setDate] = useState(todayStr); // Default ke hari ini
  const [showResults, setShowResults] = useState(false);
  const wrapperRef = useRef(null);

  // Fungsi Utama memicu pencarian
  const triggerSearch = (queryName, queryBahasa, queryDate) => {
    if (onSearch) {
      onSearch({
        name: queryName !== undefined ? queryName : searchQuery,
        bahasa: queryBahasa !== undefined ? queryBahasa : bahasa,
        date: queryDate !== undefined ? queryDate : date
      });
    }
  };

  // Trigger pencarian pertama kali saat halaman dimuat
  useEffect(() => {
    triggerSearch(searchQuery, bahasa, todayStr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounce untuk pengetikan nama
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length >= 3 || searchQuery.length === 0) {
        triggerSearch(searchQuery, bahasa, date);
      }
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setShowResults(value.length >= 3);
  };

  const handleBahasaChange = (e) => {
    const value = e.target.value;
    setBahasa(value);
    triggerSearch(searchQuery, value, date);
  };

  const handleDateChange = (selectedDates, dateStr) => {
    if (selectedDates.length > 0) {
      setDate(dateStr);
      triggerSearch(searchQuery, bahasa, dateStr);
    }
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setShowResults(false);
    triggerSearch('', bahasa, date);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 mb-4 border">
      <div className="row g-3 align-items-end">
        {/* CARI NAMA */}
        <div className="col-12 col-md-6">
          <label className="form-label fw-bold small">Cari Jadwal Psikolog dan Buat Janji</label>
          <div className="card-search-wrapper" ref={wrapperRef}>
            <div className="card-search-input-group">
              <span className="card-search-icon-left">🔍</span>
              <input
                type="text"
                className="card-search-input"
                placeholder="Ketik nama psikolog min 3 huruf..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
              {searchQuery && (
                <span className="card-search-icon-clear" onClick={handleClearSearch} style={{ cursor: 'pointer' }}>
                  &times;
                </span>
              )}
            </div>
          </div>
        </div>

        {/* PILIH BAHASA */}
        <div className="col-12 col-md-3">
          <label className="form-label fw-bold small">Pilih Spesialisasi</label>
          <div className="card-search-input-group">
            <span className="card-search-icon-left text-danger"><i className="bi bi-translate"></i></span>
            <select className="card-search-input card-search-select" value={bahasa} onChange={handleBahasaChange}>
              <option value="">Semua Bahasa</option>
              <option value="Indonesia">Bahasa Indo</option>
              <option value="English">Bahasa English</option>
              <option value="Bilingual">Bahasa Bilingual</option>
            </select>
          </div>
        </div>

        {/* PILIH TANGGAL */}
        <div className="col-12 col-md-3">
          <label className="form-label fw-bold small">Pilih Tanggal</label>
          <div className="card-search-input-group">
            <span className="card-search-icon-left">📅</span>
            <Flatpickr
              className="card-search-input"
              value={date}
              onChange={handleDateChange}
              options={{ dateFormat: "Y-m-d", minDate: "today", disableMobile: "true" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchFilter;